module.exports = __webpack_public_path__ + "media/application/images/svgs/arrow-left-circle-8c162b6c337586eab9231d383eea9c01.svg";